import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { formatExpense } from "../shared/FinancialViewHelpers";
import format from "../../../shared/formatters";

const TeamMemberSplit = ({ income }) => (
  <div className="transaction-gci-content">
    <Row>
      <Col xs={2}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>Brokerage Split</label>
        {income.brokerage_split_amount && (
          <span>{formatExpense(format.currency(income.brokerage_split_amount))}</span>
        )}
      </Col>
      <Col xs={5} />
      <Col xs={1} />
      <Col xs={2} className="text-right" />
      <Col xs={2} className="text-right">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>Subtotal</label>
        {income.brokerage_split_line_total && (
          <span>{format.currency(income.brokerage_split_line_total)}</span>
        )}
      </Col>
    </Row>
    <Row style={{ paddingTop: "15px" }}>
      <Col xs={2}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>Royalty</label>
        {income.royalty_amount && <span>{formatExpense(format.currency(income.royalty_amount))}</span>}
      </Col>
      <Col xs={5} />
      <Col xs={1} />
      <Col xs={2} className="text-right" />
      <Col xs={2} className="text-right">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>Subtotal</label>
        {income.royalty_line_total && <span>{format.currency(income.royalty_line_total)}</span>}
      </Col>
    </Row>
  </div>
);

TeamMemberSplit.propTypes = {
  income: PropTypes.shape({
    brokerage_split_amount: PropTypes.number,
    brokerage_split_line_total: PropTypes.number,
    royalty_amount: PropTypes.number,
    royalty_line_total: PropTypes.number,
  }).isRequired,
};

export default TeamMemberSplit;
